<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h5 class="modal-title">Reschedule Appointment</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form v-if="!loading">
          <div class="row">
            <div class="col">
              <label>Appointment Date & Time</label>
              <input
                @change="change_handler"
                name="appointment_date"
                type="datetime-local"
                class="form-control"
                placeholder="appointment_date"
                v-model="formattedAppointmentDate"
              />
            </div>
            <div class="col">
              <label>Practitioner</label>
              <input
                @change="change_handler"
                :value="doc"
                name="doc"
                type="text"
                class="form-control"
                placeholder="Doc"
              />
            </div>

            <div class="col">
              <label>Note</label>
              <input
                @change="change_handler"
                :value="note"
                name="note"
                type="text"
                class="form-control"
                placeholder="note"
              />
            </div>
          </div>

          <div style="display: inline" class="row">
            <button
              @click="submitHandler"
              class="mt-2 btn btn-success"
              style="
                display: flex;
                color: black;
                width: auto;
                align-self: flex-end;
                justify-content: flex-end;
                float: right;
              "
            >
              Submit
            </button>
          </div>
        </form>

        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            align-self: center;
            color: black;
            font-weight: bold;
          "
          v-if="loading"
        >
          Loading...
        </div>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
        <button type="button" class="btn btn-primary" @click="saveModal">Save</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";

export default {
  name: "Reschedule",
  data() {
    return {
      loading: true,
      appointment_date: "",
      doc: "",
      note: "",
    };
  },
  computed: {
    formattedAppointmentDate: {
      get() {
        return this.appointment_date
          ? this.appointment_date.slice(0, 16) // Removes seconds
          : "";
      },
      set(value) {
        this.appointment_date = value;
      },
    },
  },
  props: {
    appointment_id: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save");
    },
    change_handler(e) {
      this[e.target.name] = e.target.value;
    },

    async submitHandler(event) {
      event.preventDefault();
      this.loading = true;
      const url = "reschedule_appointment";
      const body = {
        appointment_id: this.appointment_id,
        appointment_date: this.formattedAppointmentDate,
        doc: this.doc,
        note: this.note,
      };
      console.log(body);

      const resp = await generalApiRequest(url, "POST", body, 1);
      if (resp) {
        this.loading = false;
        this.$emit("close");
        // this.$emit('reload-content');
        window.location.reload();
      }
    },

    async api_call() {
      const url = "get_appointment_by_id";
      const body = {
        appointment_id: this.appointment_id,
      };

      const resp = await generalApiRequest(url, "POST", body, 1);
      this.appointment_date = resp.appointment_date;
      this.doc = resp.doc;
      this.note = resp.note;
      this.loading = false;
    },
  },
  mounted() {
    this.api_call();
    console.log(this.appointment_id);
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto; /* Scrollable content */
  flex-grow: 1; /* Allow the body to grow and take available space */
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.patient-profile {
  margin: 0;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

/*  */
</style>
